'use client';

import type { FC } from 'react';

import { cn } from '@/lib/utils';

import {
    Select,
    SelectContent,
    SelectItem,
} from '@/components/molecules/Select';

import type { IntegrationMenuSelectConfigType } from '@/static/content/pl/integration/integration-side-content';

export interface SelectMenuProps {
    mobileList: IntegrationMenuSelectConfigType[];
}

const SelectMenu: FC<SelectMenuProps> = ({ mobileList }) => (
    <Select
        placeholder="Wybierz z listy"
        className="md:!hidden"
    >
        <SelectContent>
            {mobileList.map(({ id, name, href }) => (
                <SelectItem
                    key={id}
                    id={id}
                    value={id}
                    data-test-id={`section-integration-side-mobile-category-${id}`}
                >
                    <a
                        href={href}
                        className={cn(
                            'flex cursor-pointer items-center gap-x-4 py-2 text-typo-primary md:pr-4',
                        )}
                        data-test-id={`integration-side-select-content-${id}`}
                    >
                        <span className="text-sm font-extrabold">{name}</span>
                    </a>
                </SelectItem>
            ))}
        </SelectContent>
    </Select>
);

export default SelectMenu;
